
<scroll-area class="work-area workarea" ref="workArea">
  <div class="container-fluid container-max">
    <div class="em-block">
      <div class="em-child">
        <div class="row">
          <div class="col">
            <h2>General Settings</h2>
            <hr>
          </div>
        </div>
        <view-settings-dashboard></view-settings-dashboard>
      </div>
    </div>
    <view-settings-limits></view-settings-limits>
    <div class="em-block">
      <div class="em-child">
        <div class="row">
          <div class="col">
            <label for="reference_name">Reference Name</label>
            <input type="text" id="reference_name" :value="selectedObjectModel.reference_name" disabled>
          </div>
        </div>
      </div>
    </div>
  </div>
</scroll-area>
